const SCALE = 1.5;

export const generatePdfThumbnails = async source => {
  const pdflib = window.pdfjsLib;
  pdflib.GlobalWorkerOptions.workerSrc =
    'https://unpkg.com/pdfjs-dist@4.0.379/build/pdf.worker.mjs';

  const pdfDocument = await pdflib.getDocument(source);
  const pdfPages = [];

  pdfDocument.promise.then(
    async pdf => {
      const pageCount = pdf._pdfInfo.numPages;
      const pageArray = [...new Array(pageCount).keys()];

      for (const pageNumber of pageArray) {
        await pdf.getPage(pageNumber + 1).then(page => {
          const viewport = page.getViewport({ scale: SCALE });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          canvas.height = viewport.height;
          canvas.width = viewport.width;

          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          };
          const renderTask = page.render(renderContext);

          return renderTask.promise.then(x => {
            const thumbnail = canvas.toDataURL();

            return pdfPages.push({
              page: pageNumber + 1,
              thumbnail,
            });
          });
        });
      }
    },
    error => console.error({ error }),
  );

  return pdfPages;
};
